import "./navbar.css";
import { useState } from "react";

export default function NavBar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <div className={`Nav ${isMobileMenuOpen ? "mobile" : ""}`}>
        <div className="NavLeft">
          
          <a href="#home"><img src="./images/fav_icon.png" alt="Pyramid Industries Logo" /></a>
        </div>
        <div className="hamburger" onClick={toggleMobileMenu}>
          <i className="fa-solid fa-bars"></i>
        </div>
        <div className="NavCenter">
          <ul className="navList">
            <li className="navListItem">
              <a href="#home">HOME</a>
            </li>
            <li className="navListItem">
              <a href="#about">ABOUT US</a>
            </li>
            <li className="navListItem">
              <a href="#projects">PROJECTS</a>
            </li>
            <li className="navListItem">
              <a href="#partners">PARTNERS</a>
            </li>
            <li className="navListItem">
              <a href="#contact">CONTACT US</a>
            </li>
          </ul>
        </div>
        <div className="NavRight">
          <a href="https://www.facebook.com/" aria-label="Facebook">
            <i className="fa-brands fa-square-facebook"></i>
          </a>
          <a href="https://www.instagram.com/" aria-label="Instagram">
            <i className="fa-brands fa-square-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/" aria-label="LinkedIn">
            <i className="fa-brands fa-linkedin"></i>
          </a>
          <a href="https://www.pinterest.com/" aria-label="Pinterest">
            <i className="fa-brands fa-square-pinterest"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
